<template>
  <section class="shimmer-section">
    <div class="shimmer-row">
      <div v-for="index in 9" :key="index" class="shimmer-col"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ShimmerCasino'
}
</script>

<style scoped>
.shimmer-section {
  padding: 16px;
}

.shimmer-row {
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  gap: 16px;
}

.shimmer-col {
  height: 60px;
  width: 60px;
  border-radius: 5px;
  background: #e0e0e0;
  background-image: linear-gradient(
      to right,
      #e0e0e0 0%,
      #f0f0f0 20%,
      #e0e0e0 40%,
      #e0e0e0 100%
  );
  background-repeat: no-repeat;
  background-size: 800px 140px;
  position: relative;
  overflow: hidden;
  animation: placeholderShimmer 1s linear infinite;
}

@keyframes placeholderShimmer {
  0% {
    background-position: -800px 0;
  }
  100% {
    background-position: 800px 0;
  }
}
</style>